var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-app-bar',{attrs:{"back-to":_vm.backTo}},[_vm._v(" Ordem - "+_vm._s(_vm.$$_ordem.orcidordemcarregamento)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }